import { state } from "../store";
import { setRoot } from "../render";
import type { BusinessType } from "../types";

const TYPES: { id: BusinessType; label: string }[] = [
  { id: "整備工場",     label: "🔧 整備工場" },
  { id: "中古車販売店", label: "🚗 中古車販売" },
  { id: "兼業",         label: "🏪 兼業" },
  { id: "その他",       label: "💡 その他" },
];

export function renderStep4() {
  const draft = state.draft;
  setRoot(`
    <header class="text-center pb-3 border-b">
      <h1 class="font-bold text-lg">💼 業種・相談内容</h1>
      <p class="text-xs text-gray-500 mt-1">Step 4 / 5</p>
    </header>

    <div class="mt-4">
      <span class="text-sm text-gray-600">業種</span>
      <div class="mt-1 grid grid-cols-2 gap-2">
        ${TYPES.map((t) => `
          <button data-type="${t.id}" class="type-btn border rounded p-3 text-center text-sm">
            ${t.label}
          </button>
        `).join("")}
      </div>
    </div>

    <label class="block mt-4">
      <span class="text-sm text-gray-600">相談内容</span>
      <textarea id="topic-input" rows="4"
        class="mt-1 w-full border rounded p-2 text-sm"
        placeholder="例：車検リマインドの仕組みを導入してみたい">${escapeHtml(draft.consultation_topic)}</textarea>
    </label>

    <div class="mt-auto pt-4 flex gap-2">
      <button id="back-btn" class="flex-1 bg-gray-300 text-gray-800 py-3 rounded">戻る</button>
      <button id="next-btn" disabled class="flex-[2] bg-gray-300 text-white py-3 rounded font-bold">次へ</button>
    </div>
  `);

  if (draft.business_type) {
    const sel = document.querySelector<HTMLElement>(`.type-btn[data-type="${draft.business_type}"]`);
    if (sel) selectType(draft.business_type, sel);
  }

  document.querySelectorAll<HTMLButtonElement>(".type-btn").forEach((b) => {
    b.addEventListener("click", () => selectType(b.dataset.type as BusinessType, b));
  });
  document.getElementById("topic-input")!.addEventListener("input", validate);
  document.getElementById("back-btn")!.addEventListener("click", async () => {
    const { renderStep3 } = await import("./step3Customer");
    renderStep3();
  });
}

function selectType(type: BusinessType, btn: HTMLElement) {
  state.draft.business_type = type;
  document.querySelectorAll<HTMLElement>(".type-btn").forEach((b) => {
    b.className = "type-btn border rounded p-3 text-center text-sm";
  });
  btn.className = "type-btn bg-brand text-white rounded p-3 text-center text-sm font-bold";
  validate();
}

function validate() {
  const topic = (document.getElementById("topic-input") as HTMLTextAreaElement).value.trim();
  state.draft.consultation_topic = topic;
  const ok = !!state.draft.business_type && !!topic;
  const next = document.getElementById("next-btn") as HTMLButtonElement;
  next.disabled = !ok;
  next.className = ok
    ? "flex-[2] bg-brand text-white py-3 rounded font-bold"
    : "flex-[2] bg-gray-300 text-white py-3 rounded font-bold";
  if (ok) {
    next.onclick = async () => {
      const { renderStep5 } = await import("./step5Confirm");
      renderStep5();
    };
  }
}

function escapeHtml(s: string): string {
  return s.replace(/[&<>"']/g, (c) => ({
    "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;"
  }[c]!));
}
